export const propertyFormConfig = {
  name: {
    iconDim: 24,
  },
  propHeight: 32,
  // inputHeight: '32px',
  fontSize: 20,
  select1Height: '24px',
  chipHeightPx: 20,
}
